"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../shared/components/table_actions/TableActionDelete");
var TableActionEdit_1 = require("../../../../../../shared/components/table_actions/TableActionEdit");
var WrapTableActions_1 = require("../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var TableMenuIsDeprecated_1 = require("../../../../../../shared/components/table_menus/TableMenuIsDeprecated");
var ButtonLockLockAll_1 = require("../../../../../../shared/components/buttons/ButtonLockLockAll");
var ButtonLockUnLockAll_1 = require("../../../../../../shared/components/buttons/ButtonLockUnLockAll");
var CfgLanguageList = /** @class */ (function (_super) {
    __extends(CfgLanguageList, _super);
    function CfgLanguageList(props) {
        var _this = _super.call(this, props) || this;
        _this.columns = [
            {
                title: 'Название',
                dataIndex: _this.props.data.dk_title,
                key: _this.props.data.dk_title,
                width: 200,
            }, {
                title: 'Код',
                dataIndex: _this.props.data.dk_code,
                key: _this.props.data.dk_code,
                align: "center",
                width: 100,
            }, {
                title: 'Изменен',
                dataIndex: _this.props.data.dk_date_added,
                key: _this.props.data.dk_date_added,
                align: "center",
                width: 200,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_changed.format(_this.props.state.getDateTimeFormat())));
                }
            }, {
                title: 'Актуальная',
                dataIndex: _this.props.data.dk_is_deprecated,
                key: _this.props.data.dk_is_deprecated,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(TableMenuIsDeprecated_1.default, { notDeprecatedTexts: { menu: "Пометить как актуальный", text: "Да" }, deprecatedTexts: { menu: "Пометить как неактуальный", text: "Нет" }, record: { key: record.key, title: record.title, deprecated: record.is_deprecated }, onDeprecateClick: _this.doDeprecateAction.bind(_this) }));
                },
                filters: [
                    { text: 'Устаревшая', value: 'true' },
                    { text: 'Актуальная', value: 'false' },
                ],
                filterMultiple: false,
                onFilter: function (value, record) { return record.is_deprecated === (value === 'true'); },
                sorter: function (a, b) { return _this.bool2Int(a.is_deprecated) - _this.bool2Int(b.is_deprecated); },
                width: 150,
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C", onClick: function () { _this.onEditLanguageClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteClick(record); } }))); },
                width: 100
            }
        ];
        return _this;
    }
    CfgLanguageList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0
        }, function () {
            _this.props.data.LoadData();
        });
        this.props.state.setExtBreadCrumbPath([]);
    };
    CfgLanguageList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    CfgLanguageList.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize
            }, function () {
                nextProps.data.LoadData();
            });
        }
    };
    CfgLanguageList.prototype.doDeprecateAction = function (Key, Title, Lock) {
        this.props.data.SetIsDeprecated(Key, Lock, function () {
            if (Lock) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041B\u043E\u043A\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044F ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u043F\u043E\u043C\u0435\u0447\u0435\u043D\u0430 \u043A\u0430\u043A \u043D\u0435\u0430\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u0430\u044F"));
            }
            else {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041B\u043E\u043A\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044F ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u043F\u043E\u043C\u0435\u0447\u0435\u043D\u0430 \u043A\u0430\u043A \u0430\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u0430\u044F"));
            }
        });
    };
    CfgLanguageList.prototype.bool2Int = function (val) {
        if (val) {
            return 1;
        }
        else {
            return 0;
        }
    };
    CfgLanguageList.prototype.onEditLanguageClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record);
        }
    };
    CfgLanguageList.prototype.onDeleteClick = function (record) {
        this.props.data.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u041B\u043E\u043A\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044F ",
                React.createElement("b", null,
                    "[",
                    record.title,
                    "]"),
                " \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D\u0430"));
        });
    };
    CfgLanguageList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        this.setState({ pageNum: _page, pageSize: PageSize }, function () {
            _this.props.data.LoadData(function () {
                if (_this.props.onPageConfigChanged) {
                    _this.props.onPageConfigChanged(_page, PageSize);
                }
            });
        });
    };
    CfgLanguageList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.props.data.LoadData();
        }
        if (action === "create") {
            if (this.props.onNewClick) {
                this.props.onNewClick();
            }
        }
    };
    CfgLanguageList.prototype.onLockAllClick = function () {
        this.props.data.SetAllIsDeprecated(true, function () {
            notificationHelper_1.default.ShowTextTopRightInfoNotify('Все локализации помечены как неактуальные !');
        });
    };
    CfgLanguageList.prototype.onUnLockAllClick = function () {
        this.props.data.SetAllIsDeprecated(false, function () {
            notificationHelper_1.default.ShowTextTopRightInfoNotify('Все локализации помечены как актуальные !');
        });
    };
    CfgLanguageList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать", refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) },
                React.createElement(antd_1.Popconfirm, { placement: "bottom", title: "Отметить как не актуальные ?", okText: "\u0414\u0430", cancelText: "\u041D\u0435\u0442", onConfirm: this.onLockAllClick.bind(this) },
                    React.createElement(ButtonLockLockAll_1.default, { hint: "Отметить как не актуальные", onClick: function () { } })),
                React.createElement(antd_1.Popconfirm, { placement: "bottom", title: "Отметить как актуальные ?", okText: "\u0414\u0430", cancelText: "\u041D\u0435\u0442", onConfirm: this.onUnLockAllClick.bind(this) },
                    React.createElement(ButtonLockUnLockAll_1.default, { hint: "Отметить как актуальные", onClick: function () { } }))),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.columns, dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D"),
                            " : [",
                            record.date_added.format(_this.props.state.getDateTimeFormat()),
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D"),
                            " : [",
                            record.date_changed.format(_this.props.state.getDateTimeFormat()),
                            "]")));
                }, scroll: { x: true } })));
    };
    return CfgLanguageList;
}(React.Component));
exports.default = CfgLanguageList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cfg_language/ui/component/CfgLanguageList.tsx
// module id = 2165
// module chunks = 0